const ICON_LABELS = {
  "console-home": "H",
  "application-hub": "A",
  access: "U",
  membership: "M",
  "range-setup": "S",
  resources: "R",
  reservations: "B",
  events: "E",
  chapters: "C",
  "staff-portal": "P",
  "daily-ops": "O",
  maintenance: "M",
  armory: "R",
  finance: "$",
  donations: "D",
  communications: "C",
  notifications: "N",
  "non-members": "G",
  accounting: "$",
  audit: "A",
  insights: "I",
  leads: "L",
  payments: "$",
  compliance: "S",
  equipment: "Q",
  launch: "L",
  reports: "R"
};

const IMAGE_ICONS = {
  "console-home": "/app-icons/console_home_icon.svg",
  "application-hub": "/app-icons/application_hub_icon.svg",
  membership: "/app-icons/membership_icon.png",
  "range-setup": "/app-icons/range_setup_icon.svg",
  resources: "/app-icons/range_inventory_icon.svg",
  reservations: "/app-icons/reservations_icon.svg",
  events: "/app-icons/programs_events_icon.svg",
  chapters: "/app-icons/chapters_icon.svg",
  "staff-portal": "/app-icons/staff_portal_icon.svg",
  "daily-ops": "/app-icons/range_operations_icon.svg",
  maintenance: "/app-icons/maintenance_hub_icon.svg",
  armory: "/app-icons/armory_icon.svg",
  leads: "/app-icons/leads_icon.svg",
  payments: "/app-icons/payments_icon.svg",
  compliance: "/app-icons/documents_icon.svg",
  communications: "/app-icons/support_icon.svg",
  notifications: "/app-icons/notifications_icon.svg",
  "non-members": "/app-icons/non_members_icon.svg",
  insights: "/app-icons/insights_icon.svg"
};

export function ApplicationIcon({ appKey = "default", label }) {
  const imageSrc = IMAGE_ICONS[appKey];
  const iconLabel = label || ICON_LABELS[appKey] || String(appKey || "A").slice(0, 1).toUpperCase();

  if (imageSrc) {
    return (
      <span className={`application-icon application-icon-${appKey} application-icon-has-image`} aria-hidden="true">
        <img src={imageSrc} alt="" />
      </span>
    );
  }

  return (
    <span className={`application-icon application-icon-${appKey}`} aria-hidden="true">
      <span>{iconLabel}</span>
    </span>
  );
}
